<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
    [navigation]="navigation.default" [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center px-8 pt-6">
        <img class="w-48" src="images/logo/logo.png" alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none sm:h-20 md:px-6 print:hidden">
    @if (!isScreenSmall) {
      <!-- Logo -->
      <div class="mx-2 flex items-center lg:mr-8">
        <div class="hidden lg:flex">
          <img class="w-48 dark:hidden" src="images/logo/logo-text.svg" />
          <img class="hidden w-48 dark:flex" src="images/logo/logo-text-on-dark.svg" />
        </div>
        <img class="flex w-8 lg:hidden" src="images/logo/logo.png" />
      </div>
      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation class="mr-2" [name]="'mainNavigation'"
      [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
    }
    <!-- Navigation toggle button -->
    @if (isScreenSmall) {
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>
    }
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      @if (envConfigService.envConfig.enableMultiLanguage) {
        <languages></languages>
      }
      @if (envConfigService.envConfig.enableFullScreen) {
        <fuse-fullscreen class="hidden md:block"
        ></fuse-fullscreen>
      }
      @if (envConfigService.envConfig.enableGlobalSearch) {
        <search [appearance]="'bar'"></search>
      }
      @if (envConfigService.envConfig.enableShortcuts) {
        <shortcuts></shortcuts>
      }
      @if (envConfigService.envConfig.enableInboxMessages) {
        <messages></messages>
      }
      @if (envConfigService.envConfig.enableNotifications) {
        <notifications></notifications>
      }
      @if (envConfigService.envConfig.enableChats) {
        <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()"
          >
          <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
        </button>
      }
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex w-full flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <div class="flex flex-row p-3 px-5 sm:py-2  bg-card dark:bg-transparent border-b">
        <!-- Custome title -->
        <h2 class="text-2xl md:text-2xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
          {{customerHeaderService.title()}}
        </h2>
        @if (customerHeaderService.showRouterLink()) {
          <button mat-mini-fab color="primary" class="mx-5"
            [routerLink]="customerHeaderService.newEntityRouterLink()"><mat-icon>add</mat-icon> </button>
          }
        </div>
        <router-outlet></router-outlet>
      }
    </div>

    <!-- Footer -->
    <app-footer></app-footer>
  </div>

  <!-- Quick chat -->
  @if (envConfigService.envConfig.enableChats) {
    <quick-chat #quickChat="quickChat"></quick-chat>
  }